import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Hero from '../components/hero';
import SideBySide from '../components/side-by-side';
// import TeamTile from "../components/team-tile";
// import TeamGrid from "../components/team-grid";
// import IntegrationsGrid from "../components/integrations-grid"
// import IntegrationsGrid from "../components/integrations-grid"
import IntegrationsGrid from '../components/integrations-grid';
import Carousel from '../components/carousel';
import DialogButton from '../components/dialogButton';

import Img from 'gatsby-image';
import '../styles/cannabis-online-ordering.css';

const Online = () => {
    const data = useStaticQuery(graphql`
        query {
            hero: file(relativePath: { eq: "background-online-order.png" }) {
                childImageSharp {
                    fluid(maxWidth: 2600, jpegQuality: 80) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            onlineOrdering: file(relativePath: { eq: "online-ordering.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            onlineMobile: file(relativePath: { eq: "online-order-phone.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            onlinePos: file(relativePath: { eq: "online-pos.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            onlineLog: file(relativePath: { eq: "online-log.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            performance: file(relativePath: { eq: "online-performance.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            account: file(relativePath: { eq: "online-account.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            delivery: file(relativePath: { eq: "delivery.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `);

    return (
        <Layout>
            <SEO
                title="Cannabis Online Ordering"
                url="/cannabis-online-ordering"
                description="Weave’s online ordering is seamlessly integrated into our point of sale system. Your customers can not only place orders, but they also have access to their purchase history, loyalty points, current order status, and the ability to update profile information."
            />
            <Hero
                className="online-ordering"
                image={data.hero.childImageSharp.fluid}
            >
                <div className="cannabis-flex-container">
                    <div className="cannabis-flex-copy-container">
                        <div>
                            <h1>Online Ordering</h1>
                            <p>
                                An online ordering system that's seamlessly
                                integrated into your point of sale. Finally.
                            </p>
                            <ul>
                                <li>
                                    Your menu is updated with real-time
                                    inventory data
                                </li>
                                <li>
                                    Orders are sent directly to the point of
                                    sale when submitted
                                </li>
                                <li>
                                    Customers can access their purchase history,
                                    loyalty points, order status, and more
                                </li>
                            </ul>
                        </div>
                        <div className="btns">
                            <DialogButton
                                analyticsValue={3}
                                className="cta"
                                key="talk"
                            >
                                Book demo
                            </DialogButton>
                        </div>
                    </div>
                    <Img
                        className="online-order-mobile-image-container"
                        fluid={data.onlineMobile.childImageSharp.fluid}
                        imgStyle={{ objectPosition: 'left' }}
                    />
                </div>
            </Hero>
            <div className="parallax-section parallax-white">
                <SideBySide
                    buttonsList={[
                        <DialogButton key="one">Lets see it</DialogButton>,
                    ]}
                    copy="Forget about swapping tabs and missing orders. Weave’s online ordering is seamlessly integrated into our point of sale system and shares all of its intelligence including discounts, purchase limits, and taxes. The order appears directly in Weave, and gives your budtenders a simple order checklist right in the terminal."
                    image={data.onlinePos.childImageSharp.fluid}
                    imagePosition={'left'}
                    sideHeader="Point of Sale Integration"
                />
            </div>
            <div className="parallax-section parallax-white">
                <SideBySide
                    copy="Online ordering designed for the modern consumer. Customers submit an online order on any device, receive a text confirmation, and come into the dispensary when their order is ready to be picked up."
                    image={data.onlineOrdering.childImageSharp.fluid}
                    imagePosition={'right'}
                    sideHeader="Simple Design for any Device"
                />
            </div>
            <div className="parallax-section parallax-white">
                <SideBySide
                    copy="Online ordering is convenient for the customer, but what's in it for the dispensary? Every Weave dispensary that implements online ordering significantly improves their average order size and profitability."
                    image={data.performance.childImageSharp.fluid}
                    imagePosition={'left'}
                    sideHeader="Improved Business Performance"
                />
            </div>

            <div className="parallax-section parallax-white">
                <SideBySide
                    buttonsList={[
                        <DialogButton key="one">Request Demo</DialogButton>,
                    ]}
                    copy="Online shoppers have full access to their order history, loyalty points and profile. Customers can apply loyalty points to their order or update personal information like driver’s license and contact information."
                    image={data.account.childImageSharp.fluid}
                    imagePosition={'right'}
                    sideHeader="Customer History and Loyalty"
                />
            </div>
            <div className="parallax-section parallax-white">
                <SideBySide
                    copy="Easily oversee the online ordering process and ensure nothing falls through the cracks with Weave’s real time dashboard. Dispensaries can see where the order is during its lifecycle, which location received the order, and more…
"
                    image={data.onlineLog.childImageSharp.fluid}
                    imagePosition={'left'}
                    sideHeader="Real-Time Order Log"
                />
            </div>
            <div className="parallax-section parallax-white">
                <SideBySide
                    copy="Coming soon to a website near you."
                    image={data.delivery.childImageSharp.fluid}
                    imagePosition={'right'}
                    sideHeader="Delivery?"
                    aspect="square"
                />
            </div>
            <div className="parallax-section parallax-white">
                <IntegrationsGrid
                    header="API Integrations"
                    copy="We understand we can't do it all. By partnering with the best in the industry, we make sure you and your customers have a seamless end to end experience."
                />
            </div>
            <Carousel />
        </Layout>
    );
};

export default Online;
